import React from 'react';
import classNames from 'classnames';

import sortDownButton from 'assets/icons/sort-down-button.svg';
import sortUpButton from 'assets/icons/sort-up-button.svg';
import thick from 'assets/icons/white-thick.svg';

import './styles.css';

const Status = ({status}) => {
  const pending = status == 'Pending';

  return (
    <div
      className={classNames('Collapsible__status colab-centered', {
        pending
      })}>
      <div className="colab-bold">{status}</div>
      {!pending && <img src={thick} alt="thick icon" />}
    </div>
  );
};

class Collapsible extends React.Component<any> {
  state = {
    isOpen: true
  };

  toggleSection = () => {
    this.setState({isOpen: !this.state.isOpen});
  };

  render() {
    const {isOpen} = this.state;
    const {className, classNameForTests} = this.props;

    return (
      <section
        className={classNames('Collapsible', className, classNameForTests)}>
        <div className="headerContainer">
          <h3 className="header">{this.props.name}</h3>
          {this.props.rightHeader}
          {this.props.status && <Status status={this.props.status} />}
          <div className="sortIcon" onClick={this.toggleSection}>
            <img src={isOpen ? sortUpButton : sortDownButton} alt="Sort Icon" />
          </div>
        </div>
        {isOpen && <div>{this.props.children}</div>}
      </section>
    );
  }
}

export default Collapsible;
